import React, { useState, useRef } from 'react';
import styles from './ClientFilterSidebar.module.css';

const CustomDateInput = ({ value, onChange, placeholder, className }) => {
    const [isDateMode, setIsDateMode] = useState(false);
    const inputRef = useRef(null);

    const handleClick = () => {
        setIsDateMode(true);
        // Small delay to ensure the input is ready
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.showPicker();
            }
        }, 100);
    };

    const handleDateChange = (e) => {
        onChange(e.target.value);
        setIsDateMode(false);
    };

    const handleBlur = () => {
        setIsDateMode(false);
    };

    const displayValue = value ? new Date(value).toLocaleDateString('en-GB') : '';

    return (
        <input
            ref={inputRef}
            type={isDateMode ? 'date' : 'text'}
            value={isDateMode ? value : displayValue}
            onChange={isDateMode ? handleDateChange : undefined}
            onClick={handleClick}
            onBlur={handleBlur}
            className={className}
            placeholder={placeholder}
            readOnly={!isDateMode}
            style={{ color: value ? 'var(--neutral-900)' : 'var(--neutral-500)' }}
        />
    );
};

export default CustomDateInput;
